<template>
    <div ref="scroller" class="new-object__group">
        <div v-show="showMore" class="btn_arrow--left btn_arrow--wrapper" :class="{disabled: leftDisabeled}" @click="scrollTo(-1, $event)">
            <i class="btn_arrow hc-icon-arrow-left" />
        </div>
        <div ref="content" class="new-object__group__wraper">
            <span
                v-if="hasAll"
                class="new-object__group__wraper__item"
                :class="{
                    'new-object__group__wraper__item--active': !filterObj.groupId,
                }"
                @click="selectGroupFn(0)"
            >全部
            </span>
            <span
                v-for="(group,index) in groupArr"
                :key="'group_' + index"
                class="new-object__group__wraper__item"
                :class="{
                    'new-object__group__wraper__item--active': filterObj.groupId === group.id,
                }"
                @click="selectGroupFn(group.id)"
            >
                <hc-input
                    v-if="varObj.editGroupId === group.id"
                    ref="edit-group"
                    v-model.trim="apiParamObj.title"
                    placeholder="请输入分组名"
                    size="mini"
                    :maxlength="20"
                    clearable
                    @blur="editGroupFn(group.id)"
                    @keyup.enter.native="editGroupFn(group.id)"
                    @input="(val)=>{ apiParamObj.title = val.replace(groupNameReg,'')}"
                />
                <span v-else>
                    <span>{{ group.title }}</span>
                    <hc-dropdown v-if="isDevEnv && !group.isSystem && !isTenantApp" trigger="click" @command="handleClick($event, group)">
                        <img class="new-object__group__wraper__item__icon" src="https://pureui-static.oss-cn-hangzhou.aliyuncs.com/paas-web/more_disabled.png" alt="">
                        <hc-dropdown-menu slot="dropdown">
                            <hc-dropdown-item command="edit">编辑</hc-dropdown-item>
                            <hc-dropdown-item v-if="canDelete" command="delete">删除</hc-dropdown-item>
                        </hc-dropdown-menu>
                    </hc-dropdown>
                    <span v-else class="icon-placeholder" />
                </span>
            </span>
            <hc-input
                v-if="varObj.addGroupBool"
                ref="addGroupInput"
                v-model.trim="apiParamObj.title"
                placeholder="请输入分组名"
                clearable
                size="mini"
                :maxlength="20"
                @blur="addGroupFn"
                @keyup.enter.native="addGroupFn"
                @input="(val)=>{ apiParamObj.title = val.replace(groupNameReg,'')}"
            />
            <div v-show="showMore" class="btn_arrow--right btn_arrow--wrapper" :class="{disabled: rightDisabled}" @click="scrollTo(1, $event)">
                <i class="btn_arrow  hc-icon-arrow-right" />
            </div>

            <span
                v-if="!isTenantApp"
                class="add-group-btn iconfont icon-addBtn"
                :class="isDevEnv && !varObj.addGroupBool ? 'add-group-btn--actived': '' "
                @click="addGroupDialogFn"
            />
        </div>
    </div>
</template>

<script>
import _ from 'lodash'

const groupNameReg = /[^\u4E00-\u9FA5A-Za-z_]/g
export default {
    props: {
        hasAll: {
            type: Boolean,
            default: true,
        },
        isDevEnv: Boolean,
        groupArr: {
            type: Array,
            default: () => [],
        },
        apiParamObj: {
            type: Object,
            default: () => ({}),
        },
        varObj: {
            type: Object,
            default: () => ({}),
        },
        filterObj: {
            type: Object,
            default: () => ({}),
        },
        canDelete: {
            type: Boolean,
            default: true,
        },

    },
    data() {
        return {
            groupNameReg,
            showMore: false,
            pageSize: 0,
            rightDisabled: false,
            leftDisabeled: true,
        }
    },
    computed: {
        isTenantApp() {
            return this.$store.state.modeling.app.isTenant
        },
    },
    watch: {
        groupArr: {
            deep: true,
            handler(val, oldv) {
                if (!_.isEqual(val, oldv)) {
                    this.reset()
                }
            },
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.updateShowMore()
            window.addEventListener('resize', this.reset)
        })
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.reset)
    },
    methods: {
        updateShowMore() {
            const scrollerWidth = this.getScollerWidth()
            this.showMore = scrollerWidth > 0
        },
        addGroupFn() {
            this.$emit('add-group')
        },
        selectGroupFn(...args) {
            this.$emit('select-group', ...args)
        },
        editGroupFn(...args) {
            this.$emit('edit-group', ...args)
        },
        addGroupDialogFn() {
            this.$emit('add-group-dialog')
            this.$nextTick(() => {
                this.$refs.addGroupInput && this.$refs.addGroupInput.focus()
                this.$refs.scroller && this.$refs.scroller.scrollTo(this.getScollerWidth() + 2, 0)
            })
        },

        handleClick(val, item) {
            this.$emit('handle-click', val, item)
            this.$nextTick(() => {
                if (this.$refs['edit-group'] && this.$refs['edit-group'].length) {
                    this.$refs['edit-group'][0] && this.$refs['edit-group'][0].focus()
                }
            })
        },

        getScollerWidth() {
            try {
                const { scroller, content } = this.$refs
                const scollerRect = scroller.getBoundingClientRect()
                const contentRect = content.getBoundingClientRect()
                return contentRect.width - scollerRect.width
            } catch (error) {
                return 0
            }
        },

        scrollTo(pageSize = 1) {
            if ((pageSize === 1 && !this.rightDisabled) || (pageSize === -1 && !this.leftDisabeled)) {
                const { scroller, content } = this.$refs
                this.pageSize += pageSize
                this.pageSize = this.pageSize <= 0 ? 0 : this.pageSize
                this.leftDisabeled = this.pageSize === 0
                this.rightDisabled = false
                scroller.scrollTo({
                    top: 0,
                    left: 820 * this.pageSize,
                    behavior: 'smooth',
                })
                setTimeout(() => {
                    const contentRect = content.getBoundingClientRect()
                    const scollerRect = scroller.getBoundingClientRect()
                    const leftDis = Math.floor(Math.abs(contentRect.left))
                    const maxDis = Math.floor((contentRect.width - scollerRect.width - scollerRect.left))
                    if ((leftDis) >= maxDis && (contentRect.left - 20) !== scollerRect.left) {
                        this.rightDisabled = true
                    } else {
                        this.rightDisabled = false
                    }
                }, 500)
            }
        },

        reset() {
            this.$nextTick(() => {
                this.updateShowMore()
                const { scroller } = this.$refs
                if (scroller) {
                    scroller.scrollTo(0, 0)
                    this.rightDisabled = false
                    this.leftDisabeled = true
                    this.pageSize = 0
                }
            })
        },
    },
}
</script>

<style lang="less" scoped>
.btn_arrow{
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    line-height: 20px;
    box-sizing: border-box;
    background-color: #F2F4FF;
    border-radius: 50%;
    text-align: center;
    &--left {
        left: 0;
    }
    &--wrapper {
        cursor: pointer;
        position: sticky;
        display: inline-block;
        background-color: #fff;
        z-index: 9;
        &.disabled {
            opacity: 0.4;
            cursor: not-allowed;
        }
    }
    &--right {
        right: 42px;
    }
}
.new-object__group{
    height: 48px;
    line-height: 48px;
    align-items: center;
    width: 100%;
    overflow-x: hidden;
    overflow-y: hidden;
    position: relative;
    &__wraper{
        white-space: nowrap;
        position: relative;
        &__item{
            padding: 0 16px;
            display: inline-block;
            font-size: 14px;
            color:rgba(0, 0, 0, 0.85);
            cursor: pointer;
            &--active{
                color:rgba(42,106,255,1);
                position: relative;
            }
            &--active::after{
                content:'';
                position: absolute;
                bottom:0;
                left: 50%;
                transform: translateX(-50%);
                width: 60px;
                height: 2px;
                background:rgba(42,106,255,1);
            }
            &__icon{
                width: 12px;
                vertical-align: middle;
                position: relative;
                bottom:1px;
                left:3px;
                opacity: 0;
            }
        }
        &__item:nth-child(1) ~ &__item:hover img{
            opacity: 1;
        }
        &__item:nth-child(2) ~ &__item{
            padding: 0 8px;
            >span{
                padding-left:12px;
            }
            .icon-placeholder {
                padding-right: 12px;
            }
        }
        /deep/ .hc-input{
            width: 120px;
            height: 32px;
            .hc-input__inner{
                padding:0 28px 0 8px;
                text-align: center;
            }
        }
        .add-group-btn{
            position: sticky;
            // top: 2px;
            height: 48px;
            text-align: center;
            line-height: 48px;
            display: inline-block;
            width: 48px;
            right: 0;
            color: #e2e5f0;
            cursor: not-allowed;
            background-color: #fff;
            &--actived {
                cursor: pointer;
                color: #1F4FFF;
            }
        }
    }
    &__btn{
        &--add{
            width:88px;
            display: inline-block;
            text-align: center;
            height:36px;
            color:#FFF;
            line-height: 36px;
            border-radius:4px;
            cursor: pointer;
            font-size: 14px;
        }
        &--import{
            width: auto;
            padding: 7px 10px;
            font-size: 14px;
            height: 36px;
            margin-right: 8px;
        }
    }
}
</style>
